import { nextTick } from 'vue'

const canUseViewTransitions = () =>
  typeof document !== 'undefined' &&
  typeof document.startViewTransition === 'function'

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

export default function enableViewTransitions(router) {
  if (!canUseViewTransitions()) {
    return router
  }

  for (const method of ['push', 'replace']) {
    const originalMethod = router[method].bind(router)

    router[method] = (...args) => {
      if (prefersReducedMotion()) {
        return originalMethod(...args)
      }

      try {
        let resolveNavigation, rejectNavigation
        const navigationPromise = new Promise((resolve, reject) => {
          resolveNavigation = resolve
          rejectNavigation = reject
        })

        const transition = document.startViewTransition(async () => {
          try {
            const result = await originalMethod(...args)
            await nextTick()
            resolveNavigation(result)
          } catch (err) {
            rejectNavigation(err)
          }
        })

        transition.finished.catch(() => {
          // Ignore aborted transitions and preserve router behavior.
        })

        return navigationPromise
      } catch {
        return originalMethod(...args)
      }
    }
  }

  return router
}
